import React from 'react';
import { Link } from 'react-router-dom';


// const App = () => {
//   const getCurrentYear = () => {
//     const currentDate = new Date();
//     const currentYear = currentDate.getFullYear();
//     return currentYear;
//   };

//   // const [year, setYear] = useState(0);
// };


const Footer = () => {
  const getCurrentYear = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    return currentYear;
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Record News</h3>
            <p>Comprehensive media monitoring solutions for modern businesses.</p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Monitoring Platforms</h4>
            <ul>
              <li><a href="https://www.audio.recordnews.co.za">Audio Monitoring</a></li>
              <li><a href="https://www.print.recordnews.co.za">Print Monitoring</a></li>
              <li><a href="https://www.online.recordnews.co.za">Online Monitoring</a></li>
              <li><a href="https://www.social.recordnews.co.za">Social Media Monitoring</a></li>
              <li><a href="https://www.video.recordnews.co.za">Video Monitoring</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Info</h4>
            <p>Email: info@recordnews.co.za</p>
            <p>Alt Email: support@recordnews.co.za</p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p><li><Link to="/privacy-policy">Privacy Policy</Link></li> | &copy; { getCurrentYear() } Record News. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;